import styles from './ImageCorners.module.css'

/**
 * Per-image corner treatment chosen by the editor in the CMS (#30).
 *
 * 'square' is the historical rendering and stays the default.
 */
type CornerStyle = 'square' | 'rounded'

type CornerOptions = {
  /** Use the smaller radius intended for card / thumbnail sized images. */
  tile?: boolean
  /** Also clip overlapping children (gradients, overlays) to the same shape. */
  clip?: boolean
}

/**
 * Map a CMS `cornerStyle` value onto the class names that apply the treatment.
 *
 * Deliberately an equality check against 'rounded' rather than a `??`/`||`
 * default: legacy content has no `cornerStyle` field at all, and a cleared
 * Select stores `''`. Both must keep rendering square, so anything that is not
 * an explicit 'rounded' returns no classes and leaves the markup untouched.
 */
function cornerClass(value: unknown, options: CornerOptions = {}): string {
  if (value !== 'rounded') return ''

  return [
    styles.rounded,
    options.tile ? styles.tile : '',
    options.clip ? styles.clip : ''
  ]
    .filter(Boolean)
    .join(' ')
}

export { cornerClass }
export type { CornerStyle }
